import script from "./HeaderDropdownButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./HeaderDropdownButton.vue?vue&type=script&lang=ts&setup=true"

import "./HeaderDropdownButton.vue?vue&type=style&index=0&id=4f467a91&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f467a91"]])

export default __exports__